import type { BeforeAndAfterAttributes } from '../../../types/cms'
import { BeforeAndAfterBackground } from './styles'
import { Container, Stack } from '@mui/material'
import { SlideCarousel, Text } from 'ui-kit'
import FormattedImage from '../../FormattedImage'

const BeforeAndAfter = ({
  images,
  backgroundColour,
  title,
  textColour,
}: BeforeAndAfterAttributes) => {
  const slides = (images ?? []).filter(item => item?.images?.data)

  if (slides.length === 0) return null

  return (
    <BeforeAndAfterBackground
      bgColour={backgroundColour}
      textColour={textColour}
    >
      <Container maxWidth="lg">
        <Stack gap={6}>
          <Text variant="h2" component="h2">
            {title}
          </Text>
          <SlideCarousel
            showIndicators={slides.length > 1}
            inactiveIndicatorColour="#00000066"
            activeIndicatorColour="#000"
            indicatorSx={{
              marginTop: '4rem',
            }}
          >
            {slides.map(({ images: slideImage }) => (
              <Stack
                key={slideImage?.data?.attributes?.name}
                alignItems="center"
              >
                <FormattedImage image={slideImage} responsive />
              </Stack>
            ))}
          </SlideCarousel>
        </Stack>
      </Container>
    </BeforeAndAfterBackground>
  )
}

export default BeforeAndAfter
